"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_collapse_1 = require("react-collapse");
var SliderDetails = /** @class */ (function (_super) {
    tslib_1.__extends(SliderDetails, _super);
    function SliderDetails(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function () {
            _this.setState({
                isOpened: !_this.state.isOpened,
            });
        };
        _this.state = {
            isOpened: false,
        };
        return _this;
    }
    SliderDetails.prototype.render = function () {
        var isOpened = this.state.isOpened;
        var _a = this.props, title = _a.title, content = _a.content;
        return (react_1.default.createElement("div", { onClick: this.toggle, className: "slider__details" },
            react_1.default.createElement("button", { className: "slider__details-button " + (isOpened ? '' : 'slider__details-button_closed'), type: "button" }),
            react_1.default.createElement("h3", { className: "slider__details-title" }, title),
            react_1.default.createElement(react_collapse_1.Collapse, { isOpened: isOpened },
                react_1.default.createElement("div", { className: "slider__details-content" }, content))));
    };
    return SliderDetails;
}(react_1.default.Component));
exports.SliderDetails = SliderDetails;
